import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import './styles/global.scss'
import './styles/icon/_icon.scss'

// import VConsole from 'vconsole'
// const vConsole = new VConsole()

// if(process.env.NODE_ENV === 'development') {
//   Vue.use(vConsole)
// }

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
